export default "__VITE_ASSET__B93b5G_E__"